// NEW: UI_REVAMP
import { Box, Flex } from '@chakra-ui/react';
import dayjs from 'dayjs';
import Header from '../Header/Header';
import AppliedFilterChips from '../filter/AppliedFilterChips';
import SingleDatePicker from '../filter/SingleDatePicker';

const ResultFilterHeader = ({ isMobile, activeDate, activeSetDate, activeMaxDate }) => {
	const todayStr = dayjs(activeMaxDate).format('YYYY-MM-DD');
	const activeDateStr = dayjs(activeDate).format('YYYY-MM-DD');
	const isToday = activeDateStr === todayStr;

	const chips = !isToday
		? [
				{
					key: 'date-filter',
					label: activeDateStr,
					background: 'rgba(225, 183, 255, 0.91)',
					color: '#AB1AFF',
					onClear: () => activeSetDate(activeMaxDate),
				},
			]
		: [];

	const datePicker = (
		<SingleDatePicker
			selected={activeDate}
			onChange={activeSetDate}
			maxDate={activeMaxDate}
			isMobile={isMobile}
		/>
	);

	if (isMobile) {
		return (
			<Flex justifyContent='space-between' alignItems='center' gap={10} mt={4} w='full'>
				<AppliedFilterChips chips={chips} mt={1} mb={0} />
				<Box ml='auto'>{datePicker}</Box>
			</Flex>
		);
	}

	return (
		<Header borderRadius='full'>
			<Flex alignItems='center' gap={3} py={1} pr={{ lg: 1.5 }}>
				<AppliedFilterChips chips={chips} mt={1} mb={0} />
				{datePicker}
			</Flex>
		</Header>
	);
};

export default ResultFilterHeader;
